import React, { Component } from 'react';

import CheckboxSection from "./CheckboxSection";

const ConfiguracionBasicaActiveDirectory = (props) => {
    return (
        <div>
            <div className="row divisor-section">
                <CheckboxSection message="Controlar el tiempo máximo sin que el usuario inicie sesión: "
                    subMessage="Alcanzada la cantidad máxima de días, el usuario será bloqueado."
                    isChecked={props.maxDiasInactividad != null}
                    extencion="días"
                    value={props.maxDiasInactividad}
                    identifier="maxDiasInactividad"
                    checkboxChangeState={props.checkboxChangeState}
                    textChangeState={props.textChangeState}/>

                <CheckboxSection message="Permitir que una sesión permanezca abierta sin que el usuario esté operando: "
                    subMessage="Una vez que haya terminado el tiempo definido se cerrará la sesión. "
                    isChecked={props.minutosPermitidosInactividad != null}
                    value={props.minutosPermitidosInactividad}
                    extencion="minutos"
                    identifier="minutosPermitidosInactividad"
                    checkboxChangeState={props.checkboxChangeState}
                    textChangeState={props.textChangeState}/>
            </div>
        </div>
    );
};

export default ConfiguracionBasicaActiveDirectory;